import Vue from 'vue';
import Vuex from 'vuex';
import {
    getModule as getDecoratedModule,
    VuexModule
} from 'vuex-module-decorators';

import user from '@/store/user';
import role from '@/store/role';
import settings from '@/store/settings';
import contexts from '@/store/contexts';
import products from '@/store/products';
import indicators from '@/store/indicators';
import culture from '@/store/culture';
import connectionStatus from '@/store/connectionStatus';

Vue.use(Vuex);

interface RootState {
    version: string;
    devmode: boolean;
}

const store = new Vuex.Store<RootState>({
    state: {
        version: '0.9.0',
        devmode: false
    },
    modules: {
        user,
        role,
        settings,
        contexts,
        products,
        indicators,
        culture,
        connectionStatus
    }
});

export default store;
export const UserState = (() => getModule(user))();
export const RoleState = (() => getModule(role))();
export const SettingsState = (() => getModule(settings))();
export const ProductsState = (() => getModule(products))();
export const ContextsState = (() => getModule(contexts))();
export const IndicatorsState = (() => getModule(indicators))();
export const CultureState = (() => getModule(culture))();
export const ConnectionStatusState = (() => getModule(connectionStatus))();

// wrapper under vuex-module-decorators.getModule to auto bind our store
declare type ConstructorOf<C> = new (...args: any[]) => C;
function getModule<M extends VuexModule>(moduleClass: ConstructorOf<M>): M {
    return getDecoratedModule(moduleClass, store);
}
